(function () {
  function initializeUpsellForms(root) {
    if (!window.theme || typeof theme.AjaxProduct !== 'function') return false;

    const scope = root || document;
    const forms = Array.from(scope.querySelectorAll('.product-set-atc form'));

    if (scope.matches && scope.matches('.product-set-atc form')) {
      forms.unshift(scope);
    }

    forms.forEach(function (form) {
      if (form.dataset.ajaxProductInitialized === 'true') return;

      form.dataset.ajaxProductInitialized = 'true';
      new theme.AjaxProduct(form, '.add-to-cart');
    });

    return true;
  }

  function initializeWhenReady(attempt) {
    if (initializeUpsellForms(document) || attempt >= 20) return;

    window.setTimeout(function () {
      initializeWhenReady(attempt + 1);
    }, 100);
  }

  initializeWhenReady(0);

  document.addEventListener('shopify:section:load', function (event) {
    initializeUpsellForms(event.target);
  });

  document.addEventListener('ajaxProduct:added', function () {
    window.setTimeout(function () {
      initializeUpsellForms(document);
    }, 100);
  });

  const upsellObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          initializeUpsellForms(node);
        }
      });
    });
  });

  upsellObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// remove cart item component 
class RemoveItem extends HTMLDivElement {
  constructor() {
    super();

    this.button = this.querySelector('.cart-item-remove');

    if (!this.button) return;

    this.button.addEventListener(
      'click',
      this.removeItem.bind(this)
    );
  }

removeItem() {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: this.dataset.key,
      quantity: 0
    })
  })
  .then((response) => response.json())
  .then(() => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });
}
}

if (!customElements.get('remove-item')) {
  customElements.define(
    'remove-item',
    RemoveItem,
    { extends: 'div' }
  );
}
